//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BackendServices from "@/services/backend-services.js";
import { required } from "@/utils/validations.js";
import { noValidation } from "@/utils/validations.js";

export default {
  name: "geographyTab",
  props: ["value"],
  components: {},
  mounted: function () {
    this.loadHierarchyLists();
    this.loadGeoLists();
  },
  data: () => ({
    validForm: false,
    tab: "traits",
    retailerList: [],
    insigniaList: [],
    chainList: [],
    zoneList: [],
    districtList: [],
    countyList: [],
    borroughList: []
  }),
  methods: {
    required,
    noValidation,
    validateData: function () {
      this.$refs.form.validate().then(success => {
        if (success) {
          this.validForm = true;
          this.$emit("form-valid", this.validForm);
        } else {
          this.validForm = false;
          this.$emit("form-invalid", this.validForm);
        }
      });
    },
    updateData() {
      this.$emit("value", this.value);
    },
    clearRetailerChildren() {
      this.value.hierarchy[1].id = null;
      this.clearInsigniaChildren();
      this.loadHierarchyLists();
      this.updateData();
    },
    clearInsigniaChildren() {
      this.value.least_hierarchy_level_id = null;
      this.loadHierarchyLists();
      this.updateData();
    },
    clearZoneChildren() {
      this.value.geography[1].id = null;
      this.clearDistrictChildren();
    },
    clearDistrictChildren() {
      this.value.geography[2].id = null;
      this.clearCountyChildren();
    },
    clearCountyChildren() {
      this.value.geography[3].id = null;
      this.value.least_geo_level_id = null;
      this.loadGeoLists();
      this.updateData();
    },
    setLeastGeoID() {
      this.value.least_geo_level_id = this.value.geography[3].id;
      this.updateData();
    },
    loadHierarchyLists() {
      BackendServices.getRetailers().then(response => {
        this.retailerList = response.data;
      });
      BackendServices.getInsigniaByRetailer(this.value.hierarchy[0].id).then(
        response => {
          this.insigniaList = response.data;
        }
      );
      BackendServices.getChainsByInsignia(this.value.hierarchy[1].id).then(
        response => {
          this.chainList = response.data;
        }
      );
    },
    async loadGeoLists() {
      let levelsResponse = await BackendServices.getGeographyHierarchyLevels();
      let zoneResponse = await BackendServices.getGeographyHierarchyLevelElements(levelsResponse.data[0].id);
      this.zoneList = zoneResponse.data

      BackendServices.getDistricts().then(response => {
        this.districtList = response.data;
        if (this.value.geography[0].id != null) {
          this.districtList = this.districtList.filter(e => e.parent_id == this.value.geography[0].id)
        }
      });
      BackendServices.getCountiesByDistrict(this.value.geography[1].id).then(
        response => {
          this.countyList = response.data;
        }
      );
      BackendServices.getBorroughsByCounty(this.value.geography[2].id).then(
        response => {
          this.borroughList = response.data;
        }
      );
    }
  },
  watch: {
    value: function (newValue) {
      this.value = newValue;
    }
  }
};
